import * as React from 'react'

import ResourceMapLayout from '~/client/src/desktop/components/Resource/ResourceMapLayout'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import EquipmentMapPopup from './EquipmentMapPopup'

const EquipmentMapLayout: React.FC = () => (
  <ResourceMapLayout
    icon="equipment"
    countLabel={count => Localization.translator.xEquipment(count)}
    markerTitleFallback={Localization.translator.equipment}
    PopupComponent={EquipmentMapPopup}
  />
)

export default EquipmentMapLayout
